var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-3",attrs:{"flat":""}},[_c('p',{staticClass:"clav-content-title-1"},[_vm._v("Documentação de apoio")]),_c('DocumentacaoApoio',{attrs:{"expand":_vm.expand}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }